export default __webpack_public_path__ + "static/media/CRS_7098-HDR-min.099baf37.jpg";